import { render } from "./ui-select-option-status.vue?vue&type=template&id=335c38db&ts=true"
import script from "./ui-select-option-status.vue?vue&type=script&lang=ts"
export * from "./ui-select-option-status.vue?vue&type=script&lang=ts"

import "./ui-select-option-status.vue?vue&type=style&index=0&id=335c38db&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__